module.exports = __webpack_public_path__ + "img/award_badge_long_second_2024.24b42b49.png";